module.exports = __webpack_public_path__ + "comparison-offers.svg?7807d9a345885ee146aa741b69c10d74";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparison-offers.svg
// module id = 281
// module chunks = 2